import get from 'lodash/get';
import { useQuery } from '@apollo/client/react';
import {
  ExpressLoanSettingsDocument,
  type ExpressLoanSettingsQuery,
} from 'graphql/generated/graphql';

export type TExpressLoanSettings = NonNullable<ExpressLoanSettingsQuery['expressLoanSettings']>;

const useExpressLoanSettings = () => {
  const { data, loading, error } = useQuery(ExpressLoanSettingsDocument);
  const expressLoanSettings = get(data, 'expressLoanSettings', null);
  return { expressLoanSettings, error, loading };
};

export default useExpressLoanSettings;
